import SimuleAgora from "../button/SimuleAgora";

const FirstBlockVD = () => {
  const scrollDown = () => {
    window.scrollTo({
      top: document.getElementById("simulador").offsetTop,
      behavior: "smooth",
    });
  };

  return (
    <div className="bg-[url('assets/images/banners/bg-hero-d-mobile.webp')] md:bg-[url('assets/images/banners/bg-hero-d.webp')] bg-cover bg-no-repeat min-h-[620px] lg:min-h-[820px] relative  ">
      {/* Bloco principal com o texto */}
      <div className="flex flex-col lg:absolute lg:top-[30%] lg:left-[61%] gap-5 lg:gap-6 xl:gap-10 ">
        <h1 className=" text-white w-full text-left text-[32px] lg:text-5xl xl:text-[52px] font-bold leading-[42px] lg:!leading-[68px] px-6 pt-6 lg:px-0 lg:pt-0">
          Agora, cliente TIM <br /> economiza até 15% <br /> na conta de energia
        </h1>
        <span className="hidden lg:block font-thin text-white text-xl lg:text-3xl xl:text-[32px] text-start">
          Saiba mais e aproveite o benefício
        </span>
        <button
          className="hidden lg:block bg-white text-[#0026D9] px-8 py-4 rounded-full w-fit text-lg font-semibold hover:opacity-70 transition-opacity duration-300"
          onClick={scrollDown}
        >
          Simule agora
        </button>
      </div>
      <div className="flex lg:hidden absolute w-full bottom-0 bg-black/30 py-4 justify-center">
        <SimuleAgora title="Simule agora" variant="primary-white" />
      </div>
    </div>
  );
};

export default FirstBlockVD;
